<template>
	<div class="ks-videoeditor-timeline-bar">
		<k-btn size="s" icon icon-name="content_cut" :disabled="!can_split" @click="$emit('split')">Split at playhead</k-btn>
		<k-btn size="s" icon icon-name="delete" :disabled="!can_delete" @click="$emit('delete')">Delete</k-btn>
		<k-btn size="s" icon icon-name="delete_sweep" :disabled="!can_clear" @click="$emit('clear')">Clear</k-btn>
		<k-btn size="s" icon icon-name="add" @click="$emit('add-track', 'video')">Video track</k-btn>
		<k-btn size="s" icon icon-name="add" @click="$emit('add-track', 'overlay')">Overlay track</k-btn>
		<k-btn size="s" icon icon-name="add" @click="$emit('add-track', 'audio')">Audio track</k-btn>
		<span class="ks-videoeditor-spacer"></span>
		<k-icon small>zoom_out</k-icon>
		<input type="range" min="1" max="200" :value="zoom" class="ks-videoeditor-zoom" @input="$emit('update:zoom', Number($event.target.value))">
		<k-icon small>zoom_in</k-icon>
	</div>
</template>

<script>
export default {
	props: {
		can_split: Boolean,
		can_delete: Boolean,
		can_clear: Boolean,
		// Pixels per second
		zoom: Number
	}
}
</script>
